
import { ManagementDashboard } from "@/components/professional/dashboard/management/ManagementDashboard";

export default function ProfessionalManagement() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1">
        <div className="container mx-auto p-4">
          <ManagementDashboard />
        </div>
      </main>
    </div>
  );
}
